<template>
    <div style="display: flex; flex-direction: column; justify-content: center; align-items: center; height: 100%; background: rgb(2,0,36);
background: linear-gradient(0deg, rgba(65,102,177,1) 34%, rgba(69,112,199,1) 100%)">
        <el-card class="box-card" style="max-width: 600px; margin: 0 auto; width: 90%; background: #f6f8ff;">
            <div style="font-weight: 700; margin-bottom: 32px;">
                Log in to Projects Map Manager
            </div>
            <div style="margin-top: 16px;">
                <el-input type="email" placeholder="Email" v-model="email" required></el-input>
            </div>
            <div style="margin-top: 16px;">
                <el-input type="password" placeholder="Password" v-model="password" required></el-input>
            </div>
            <div style="margin-top: 32px; margin-bottom: 32px;">
                <div style="display: flex; align-items: center; flex-direction: row-reverse;">
                    <el-button v-loading="loading" type="primary" @click.native="handleLogin" style="width: 100%;">Log in</el-button>
                </div>
            </div>
            <div v-if="errorMessage" style="color: red; margin-top: 10px;">
                {{errorMessage}}
            </div>
            <div style="height: 40px; margin: 16px -20px -20px; background: #e1e6f6;">
                <div style="display: flex;align-items: center; justify-content: space-between; padding: 0 20px;">
                    <router-link to="/forgot-password">
                        <div style="line-height: 40px; color: #4570c7;">
                            Forgot password
                        </div>
                    </router-link>
                    <router-link to="/signup">
                        <div style="line-height: 40px; color: #4570c7;">
                            Sign up
                        </div>
                    </router-link>
                </div>
            </div>
        </el-card>
    </div>
</template>
<script>
import axios from 'axios'
export default {
    data() {
        return {
            errorMessage: null,
            loading: false,
            email: '',
            password: ''
        }
    },
    methods: {
        handleLogin() {
            this.loading = true;
            axios.post('/auth', {
                    username: this.email,
                    password: this.password
                })
                .then(response => {
                    localStorage.token = response.data.access_token
                    if (this.$route.query.next) {
                        window.location.href = '/#/login?redirect=' + encodeURIComponent(this.$route.query.next);
                    } else {
                        window.location.href = '/#/projects';
                    }
                    window.location.reload();
                })
                .catch(error => {
                    console.log(error);
                    this.errorMessage = 'Could not login with provided credentials'
                })
                .finally(() => {
                    this.loading = false;
                });
        }
    }
}
</script>